module.exports = __webpack_public_path__ + "media/images/sports_icons/tennis-f608a2f651f21489539402fa931b2f82.png";